import React, { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import ProgressBar from '../Components/upload/ProgressBar';
import UploadSection from '../Components/upload/UploadSection';
import Instruction from '../Components/upload/Instruction';
import Statistics from '../Components/upload/Statistics';

const UploadPage: React.FC = () => {
  const [status, setStatus] = useState<number>(0);
  const { t } = useTranslation();

  return (
    <Flex w="100%" minH="auto" direction="column" align="center" bg="#FFFFFF">
      <Flex w="100%" maxW="1200px" direction="column" align="center" pt="50px" pb="100px" px="24px">
        <Flex w="100%" maxW="750px" justify="center" align="center" mb="30px">
          <Text
            fontFamily="Open Sans"
            fontWeight={600}
            fontSize="30px"
            lineHeight="133%"
            letterSpacing="0.01em"
            textAlign="center"
            color="#000000"
          >
            {t('upload.verification')}
          </Text>
        </Flex>

        <Flex w="100%" mb="60px" justify="center">
          <ProgressBar status={status} />
        </Flex>

        <UploadSection status={status} setStatus={setStatus} />

        <Flex w="100%" maxW="1035px" h="2px" bg="#C1CCD1" mt="60px" mb="60px" />

        <Flex w="100%" maxW="750px" justify="center" align="center" mb="50px">
          <Text
            fontFamily="Open Sans"
            fontWeight={600}
            fontSize="30px"
            lineHeight="133%"
            letterSpacing="0.01em"
            textAlign="center"
            color="#000000"
          >
            {t('upload.helpTitle')}
          </Text>
        </Flex>

        <Instruction />

        <Flex w="100%" maxW="1035px" h="2px" bg="#C1CCD1" mt="60px" mb="60px" />

        <Flex w="100%" maxW="750px" justify="center" align="center" mb="50px">
          <Text
            fontFamily="Open Sans"
            fontWeight={600}
            fontSize="30px"
            lineHeight="133%"
            letterSpacing="0.01em"
            textAlign="center"
            color="#000000"
          >
            {t('upload.latestStatistics')}
          </Text>
        </Flex>

        <Statistics />
      </Flex>
    </Flex>
  );
};

export default UploadPage;
